// extracted by mini-css-extract-plugin
module.exports = {"keyWord":"keyWord_keyWord__3pQ6T","keyWordItem":"keyWord_keyWordItem__2yfAR","keyWordIcon":"keyWord_keyWordIcon__1Keed"};